import React from 'react';
import { ConversationSummary } from '../goFormz-agent-types';

export default function AgentConversationHistory({
  conversations,
  summarySelected
}: {
  conversations: ConversationSummary[];
  summarySelected: (conversation: ConversationSummary) => void;
}) {
  return (
    <div>
      {conversations.length === 0 && <div style={{ textAlign: 'center', fontWeight: 'bold' }}>No conversations found.</div>}
      {conversations.length > 0 && (
        <>
          {conversations.map((conversation) => (
            <div key={conversation.conversationSessionId} className="history-item" onClick={() => summarySelected(conversation)}>
              <div className="history-text">{conversation.firstMessage}</div>
              <div className="history-date">{new Date(conversation.createdDate).toLocaleString()}</div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
